import { render } from "./AccountUserOrganizations.vue?vue&type=template&id=a9b99984"
import script from "./AccountUserOrganizations.vue?vue&type=script&lang=js"
export * from "./AccountUserOrganizations.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__